export default __webpack_public_path__ + "static/media/scansWhite.7fd4a827.png";